import * as colors from "styles/colorValues.module.scss";
export const getScoreColor = (score) => {
    if (isNaN(Number(score)) || score === undefined) {
        return colors.s600;
    }
    if (score >= 0 && score <= 9) {
        return colors.score0;
    }
    if (score >= 10 && score <= 19) {
        return colors.score10;
    }
    if (score >= 20 && score <= 29) {
        return colors.score20;
    }
    if (score >= 30 && score <= 39) {
        return colors.score30;
    }
    if (score >= 40 && score <= 49) {
        return colors.score40;
    }
    if (score >= 50 && score <= 59) {
        return colors.score50;
    }
    if (score >= 60 && score <= 69) {
        return colors.score60;
    }
    if (score >= 70 && score <= 79) {
        return colors.score70;
    }
    if (score >= 80 && score <= 89) {
        return colors.score80;
    }
    if (score >= 90) {
        return colors.score90;
    }
    return colors.score0;
};
export const SOURCE_LINE_COLORS = [
    colors.turquoise,
    colors.magenta,
    colors["light-blue"],
    colors.p600,
    colors.lilac,
    colors.brown,
];
